/* GASSISA
=========================================================================================
* Descripción: 
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 23/11/2023 | Lic. José Luis Aragón Cervantes  | Creación
* ---------------------------------------------------------------------------------------
*/

import TextField from "../../ui/TextField";
import Autocomplete from "../../ui/Autocomplete";
import { Fragment, useEffect, useState, useMemo, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Tabs, Tab, Modal, IconButton, Tooltip, Typography, Divider } from "@mui/material";

import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import UpdateIcon from '@mui/icons-material/Update';
import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner';
import RepartitionIcon from '@mui/icons-material/Repartition';
import ListAltIcon from '@mui/icons-material/ListAlt';

import "../../../styles/Articulos.css";

import SizeSoftXLayout from "../../../components/leyout/SizeSoftXLayout";
import ModalBuscarArticulosSimple from "../../../components/herramientas/ModalBuscarArticulosSimple";
import MnuArticulosActions from "./MnuArticulosActions";
import ArticulosEliminar from "./ArticulosEliminar";
import SizeSoftXTableVentas from '../../leyout/SizeSoftXTableVentas';
import SizeSoftXTableExistencias from '../../leyout/SizeSoftXTableExistencias';
import AutoCompleteTools from '../../utils/AutoCompleteTools';
import SizeSoftXModalInputBox from "../../leyout/SizeSoftXModalInputBox.jsx";
import SizeSoftXModal from "../../leyout/SizeSoftXModal.jsx";
import TenantSyncModal from "../../tenantSync/TenantSyncModal.jsx";

import { useLayout } from "../../../context/System/LayoutContext";
import { useArticulos } from "../../../context/Catalogos/ArticulosContext";
import { useSesion } from "../../../context/System/SesionContext";
import { useInventarios } from "../../../context/Inventarios/InventariosContext"
import { useFormTabLock } from "../../../hooks/useFormTabLock";
import { CustomTabPanel } from "../../utils/CustomTabPanel"
import { getDateString3 } from "../../../settings/utils"
import { defaultTypes } from "../../../settings/enums";

export default function Articulos() {
    const { isLocked: isFormLocked } = useFormTabLock('articulos', {
        title: 'Artículos',
        onLockDetected: (info) => {
            console.warn(`El formulario de ${info?.title || 'Artículos'} ya está abierto en otra pestaña`);
        }
    });

    const {
        articuloSeleccionado,
        medidasList,
        listaPresentaciones,
        listaMarcas,
        listaProveedores,
        listaMateriales,
        listaFamilias,
        listaSubfamilias,
        listaColores,
        handleChangeDataArticulo,
        handleChangeDataArticuloPayload,
        statusEditArticulo, setStatusEditArticulo,
        medidaSeleccionada,
        handleChangeMedidaSeleccionada,
        handleObtenerCatalogosArticulos,
        imagenBase64,
        formularioMedidas, handleChangeFormulario,
        listaCorridas, handleObtenerCorridas, handleChangeCorridas, corridaSeleccionada,
        statusBuscarArticuloSimple,
        handleCerrarBuscarArticulo,
        handleRegistrarMedidas,
        handleConfirmarRegistrarMedidas,
        pendingSaveData,
        openConfirmSaveModal,
        setOpenConfirmSaveModal,
        statusEditable,
        handleClickGuardarCodigoBarras,
        handleClickEliminarMedidaArticulo,
        handleClickEliminarTodasMedidasArticulo,
        statusOpenCodigoBarras, setStatusOpenCodigoBarras,
        statusOpenModalEliminarMedidas, setStatusOpenModalEliminarMedidas,
        statusOpenModalEliminarTodasMedidas, setStatusOpenModalEliminarTodasMedidas,
        listaProveedoresArticulo, setListaProveedoresArticulo,
        articuloPayLoad, setArticuloPayLoad, getStructArticulosPayload,
        handleClickRegresarMainDashboard,
        handleClickNuevoArticulo,
        handleClickEditarArticulo,
        handleClickGuardarArticulo,
        handleClickEliminarArticulo,
        handleAbrirBuscarArticulo,
        setStatusOpenModalEliminarArticulo,
        statusOpenModalEliminarArticulo,
    } = useArticulos();

    const {
        listaAlmacenesExhibidoresGeneral,
        handleObtenerAlmacenesExhibidores,
        handleObtenerExistenciasAlmacenExhibidor,
        dataFiltroExistencias,
        setDataFiltroExistencias,
        setStatusWaiting,
    } = useInventarios();

    const { handleChangeTitle, handleChangeClavePaginaActual, handleOpenAlert } = useLayout();
    const { getPermisoBoton, parametrosCajaForm } = useSesion();

    const [dataArticuloExistencia, setDataArticuloExistencia] = useState({});
    const [almacenexhibidor, setAlmacenExhibidor] = useState(parametrosCajaForm.dominio);
    const [totalRegistros, setTotalRegistros] = useState(0);
    const [cantidadArticulos, setCantidadArticulos] = useState(0);
    const [filtro, setFiltro] = useState("");
    const [listChanged, setListChanged] = useState([]);
    const [rowSelectProveedores, setRowSelectProveedores] = useState({});
    const [claveArticuloExistencia, setClaveArticuloExistencia] = useState("");
    const [medidaArticuloExistencia, setMedidaArticuloExistencia] = useState("");
    const [openTenantSync, setOpenTenantSync] = useState(false);
    const navigate = useNavigate();

    const opcionesIVACompra = [
        { id: 0, ivacompra: "" },
        { id: 1, ivacompra: "NO" },
        { id: 2, ivacompra: "SI" },
    ];

    const opcionesIVAVenta = [
        { id: 0, ivaventa: "" },
        { id: 1, ivaventa: "NO" },
        { id: 2, ivaventa: "SI" },
    ];

    const exentoIVA = [
        { id: 0, exentoiva: "" },
        { id: 1, exentoiva: "NO" },
        { id: 2, exentoiva: "SI" },
    ];

    const handleChangeAlmacenExhibidor = async (e, newDat) => {
        if (newDat == undefined) return;

        setTotalRegistros(0);
        setCantidadArticulos(0);

        setAlmacenExhibidor(newDat.nombre);
        setStatusWaiting(true);
        await handleObtenerExistenciasAlmacenExhibidor(articuloSeleccionado.descripcion.trim(), newDat.nombre);
        setStatusWaiting(false);
    };

    const handleCargarExistecias = useCallback(async () => {
        if (almacenexhibidor == undefined) return;

        setTotalRegistros(0);
        setCantidadArticulos(0);

        setStatusWaiting(true);
        await handleObtenerExistenciasAlmacenExhibidor(articuloSeleccionado.descripcion.trim(), almacenexhibidor.trim());
        setStatusWaiting(false);
    }, [almacenexhibidor, articuloSeleccionado.descripcion, handleObtenerExistenciasAlmacenExhibidor]);

    const handleArticuloSeleccionado = (e) => {
        setDataArticuloExistencia(e);
        setTotalRegistros(0);
        setCantidadArticulos(0);
    };

    const handleCargarArticulo = () => {
        // ModalBuscarArticulosSimple ya carga el articulo completo y sus medidas.
    };

    const handleModalCambioCodigoBarras = () => {
        setStatusOpenCodigoBarras(true);
    };

    const handleCambioCodigoBarrasSuccess = (codigo) => {
        setStatusOpenCodigoBarras(false);
        handleClickGuardarCodigoBarras(codigo);
    };

    const handleChangeStatus = (e, row) => {
        const updatedList = listaProveedoresArticulo.map(proveedor =>
            proveedor.clavefabricante === row.clavefabricante
                ? { ...proveedor, status: e.target.checked }
                : proveedor
        );
        setListaProveedoresArticulo(updatedList);
    };

    const handleChangeProveedorSeleccionado = (e) => {
        setRowSelectProveedores(e);
    };

    const handleConvertirDataArticulos = useCallback((articulo) => {
        const trimValue = (val) => typeof val === 'string' ? val.trim() : val;
        
        setArticuloPayLoad((prev) => ({
            ...prev,
            fecharegistro: {
                ...prev.fecharegistro,
                value: trimValue(articulo.fecharegistro) ?? "",
                error: false,
                helper: "",
            },
            clavearticulo: {
                ...prev.clavearticulo,
                value: trimValue(articulo.clavearticulo) ?? "",
                error: false,
                helper: "",
            },
            descripcion: {
                ...prev.descripcion,
                value: trimValue(articulo.descripcion) ?? "",
                error: false,
                helper: "",
            },
            color: {
                ...prev.color,
                value: trimValue(articulo.color) ?? "",
                error: false,
                helper: "",
            },
            factor: {
                ...prev.factor,
                value: trimValue(articulo.factor) ?? 0,
                error: false,
                helper: "",
            },
            presentacion: {
                ...prev.presentacion,
                value: trimValue(articulo.presentacion) ?? "",
                error: false,
                helper: "",
            },
            marca: {
                ...prev.marca,
                value: trimValue(articulo.marca) ?? "",
                error: false,
                helper: "",
            },
            fabricante: {
                ...prev.fabricante,
                value: trimValue(articulo.fabricante) ?? "",
                error: false,
                helper: "",
            },
            material: {
                ...prev.material,
                value: trimValue(articulo.material) ?? "",
                error: false,
                helper: "",
            },
            familia: {
                ...prev.familia,
                value: trimValue(articulo.familia) ?? "",
                error: false,
                helper: "",
            },
            subfamilia: {
                ...prev.subfamilia,
                value: trimValue(articulo.subfamilia) ?? "",
                error: false,
                helper: "",
            },
            ivaventa: {
                ...prev.ivaventa,
                value: trimValue(articulo.ivaventa) ?? "",
                error: false,
                helper: "",
            },
            ivacompra: {
                ...prev.ivacompra,
                value: trimValue(articulo.ivacompra) ?? "",
                error: false,
                helper: "",
            },
            status: {
                ...prev.status,
                value: trimValue(articulo.status) ?? "ACTIVO",
                error: false,
                helper: "",
            },
            porcentajeiva: {
                ...prev.porcentajeiva,
                value: trimValue(articulo.porcentajeiva) ?? 0.00,
                error: false,
                helper: "",
            },
            exentoiva: {
                ...prev.exentoiva,
                value: trimValue(articulo.exentoiva) ?? "",
                error: false,
                helper: "",
            },
            imagen: {
                ...prev.imagen,
                value: trimValue(articulo.imagen) ?? defaultTypes.byteArray,
                error: false,
                helper: "",
            },
            codigocomun: {
                ...prev.codigocomun,
                value: trimValue(articulo.codigocomun) ?? "",
                error: false,
                helper: "",
            }
        }));
    }, []);

    //#region accionamientos tabs
    const [tabIndex, setTabIndex] = useState(0);
    const handleChange = (event, newValue) => {
        setTabIndex(newValue);
    };

    function a11yProps(index) {
        return {
            id: `simple-tab-${index}`,
            "aria-controls": `simple-tabpanel-${index}`,
        };
    }
    //#endregion

    useEffect(() => {
        if (!Array.isArray(listaAlmacenesExhibidoresGeneral) || listaAlmacenesExhibidoresGeneral.length === 0) {
            handleObtenerAlmacenesExhibidores("GENERAL");
        }

        handleObtenerCorridas();

        handleObtenerCatalogosArticulos();
        handleChangeTitle("Catálogo de Artículos");
        handleChangeClavePaginaActual("Artículos");
        setDataFiltroExistencias([]);
        setStatusEditArticulo(true);
    }, []);

    useEffect(() => {
        if (isFormLocked) {
            handleOpenAlert(
                `El formulario de Artículos ya está abierto en otra pestaña del navegador.\n\nPor favor, cierre la otra ventana o pestaña para continuar.`,
                "error"
            );
            setTimeout(() => {
                handleClickRegresarMainDashboard();
            }, 900);
        }
    }, [isFormLocked]);

    useEffect(() => {
        if (!Array.isArray(dataFiltroExistencias) || dataFiltroExistencias.length === 0) {
            setTotalRegistros(0);
            setCantidadArticulos(0);
            return;
        }

        const totalArticulos = dataFiltroExistencias.reduce((total, item) => {
            const sumaItem = (item.listamedidas || []).reduce(
                (acc, medida) => acc + (medida.existencia || 0),
                0
            );
            return total + sumaItem;
        }, 0);

        setTotalRegistros(dataFiltroExistencias.length);
        setCantidadArticulos(totalArticulos);
    }, [dataFiltroExistencias]);

    useEffect(() => {
        const newDat = { nombre: parametrosCajaForm.dominio };
        handleConvertirDataArticulos(articuloSeleccionado);
        handleCargarExistecias();
    }, [articuloSeleccionado]);

    //#region listas ordenadas

    const listaAlmacenesExhibidoresOrdenada = useMemo(() => {
        return listaAlmacenesExhibidoresGeneral?.slice().sort((c, d) => c.almacenexhibidor.localeCompare(d.almacenexhibidor)) || [];
    }, [listaAlmacenesExhibidoresGeneral]);

    const listaAlmacenesExhibidoresAutoComplete = useMemo(() => {
        return listaAlmacenesExhibidoresOrdenada.map((y) => ({
            id: y.id,
            nombre: y.almacenexhibidor,
        }));
    }, [listaAlmacenesExhibidoresOrdenada]);

    const listaPresentacionesAutoComplete = useMemo(() => {
        let id = 0;
        return listaPresentaciones?.slice().sort((a, b) => a.localeCompare(b))
            .map(y => ({ id: id++, presentacion: y })) || [];
    }, [listaPresentaciones]);

    const listaMarcasAutoComplete = useMemo(() => {
        let id = 0;
        return listaMarcas?.slice().sort((a, b) => a.localeCompare(b))
            .map(y => ({ id: id++, marca: y })) || [];
    }, [listaMarcas]);

    const listaColoresAutoComplete = useMemo(() => {
        let id = 0;
        return listaColores?.slice().sort((a, b) => a.localeCompare(b))
            .map(y => ({ id: id++, color: y })) || [];
    }, [listaColores]);

    const listaMaterialesAutoComplete = useMemo(() => {
        let id = 0;
        return listaMateriales?.slice().sort((a, b) => a.localeCompare(b))
            .map(y => ({ id: id++, material: y })) || [];
    }, [listaMateriales]);

    const listaProveedoresAutoComplete = useMemo(() => {
        let id = 0;
        return listaProveedores?.slice().sort((a, b) => a.localeCompare(b))
            .map(y => ({ id: id++, fabricante: y })) || [];
    }, [listaProveedores]);

    const listaFamiliasAutoComplete = useMemo(() => {
        let id = 0;
        return listaFamilias?.slice().sort((a, b) => a.localeCompare(b))
            .map(y => ({ id: id++, familia: y })) || [];
    }, [listaFamilias]);

    const listaSubfamiliasAutoComplete = useMemo(() => {
        let id = 0;
        return listaSubfamilias?.slice().sort((a, b) => a.localeCompare(b))
            .map(y => ({ id: id++, subfamilia: y })) || [];
    }, [listaSubfamilias]);

    //#endregion

    //Key actions windows
    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key.trim().toUpperCase() === 'F4') {
                event.preventDefault();
                event.stopPropagation();
                handleClickRegresarMainDashboard();
                return;
            }

            if (event.altKey && event.key.trim().toUpperCase() === 'F1') {
                event.preventDefault();
                event.stopPropagation();
                handleAbrirBuscarArticulo();
                return;
            }

            if (event.altKey && event.key.trim().toUpperCase() === 'G') {
                event.preventDefault();
                event.stopPropagation();
                handleClickGuardarArticulo();
                return;
            }

            if (event.altKey && event.key.trim().toUpperCase() === 'E') {
                event.preventDefault();
                event.stopPropagation();
                handleClickEditarArticulo();
                return;
            }

            if (event.altKey && event.key.trim().toUpperCase() === 'F3') {
                event.preventDefault();
                event.stopPropagation();
                handleClickNuevoArticulo();
                return;
            }
            
            if (event.altKey && event.key.trim().toUpperCase() === 'F11') {
                event.preventDefault();
                event.stopPropagation();
                setStatusOpenModalEliminarArticulo(true);
                return;
            }

        };
        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [handleClickRegresarMainDashboard, handleAbrirBuscarArticulo, handleClickGuardarArticulo, handleClickEditarArticulo, handleClickNuevoArticulo]);

    return (
        <Fragment>
            <SizeSoftXLayout
                titlePage="Catálogo de Artículos"
                buttonActions={<MnuArticulosActions onOpenTenantSync={() => setOpenTenantSync(true)} />}
            >
                <Box sx={{ 
                    height: 'calc(100vh - 145px)', 
                    overflowY: 'auto', 
                    position: 'relative', 
                    pb: '100px',
                    '&::-webkit-scrollbar': { width: '8px' },
                    '&::-webkit-scrollbar-thumb': { backgroundColor: '#ccc', borderRadius: '4px' }
                }}>
                    <Box className="headerArticulos" sx={{ 
                        position: 'sticky', 
                        top: 0, 
                        zIndex: 100, 
                        backgroundColor: '#fff',
                        borderBottom: '1px solid #eee',
                        overflow: 'hidden'
                    }}>
                        <div className="panelDetallesArticulo">
                            <div className="panelDetallesArticulo-main" style={{ overflowY: 'visible' }}>
                                <div className="rowDetallesArticulo rowDetallesArticulo--main-3">
                                    <TextField autoComplete="off"
                                        name="fecharegistro"
                                        label="Fecha registro:"
                                        value={getDateString3(articuloPayLoad.fecharegistro.value) || ""}
                                        disabled
                                        sx={{ width: '130px' }}
                                        size="small"
                                    />
                                    <TextField autoComplete="off"
                                        name="clavearticulo"
                                        label="Clave articulo:"
                                        value={articuloPayLoad.clavearticulo.value || ""}
                                        disabled
                                        sx={{ width: '130px' }}
                                        InputLabelProps={{ shrink: true }}
                                        size="small"
                                    />
                                    <TextField
                                        name="descripcion"
                                        label="Descripción:"
                                        value={articuloPayLoad.descripcion.value || ""}
                                        onChange={handleChangeDataArticuloPayload}
                                        disabled={statusEditArticulo}
                                        required
                                        autoComplete="off"
                                        sx={{ width: '450px' }}
                                        error={articuloPayLoad?.descripcion.error}
                                        helperText={articuloPayLoad?.descripcion.helper}
                                        inputProps={{ maxLength: 60, minLength: 10 }}
                                        size="small"
                                    />
                                </div>
                                <div className="rowDetallesArticulo rowDetallesArticulo--main-5">
                                    <TextField
                                        name="factor"
                                        label="Factor:"
                                        value={articuloPayLoad.factor.value || ""}
                                        onChange={handleChangeDataArticuloPayload}
                                        disabled={statusEditArticulo}
                                        required
                                        autoComplete="off"
                                        sx={{ width: '100%' }}
                                        error={articuloPayLoad?.factor.error}
                                        helperText={articuloPayLoad?.factor.helper}
                                        inputProps={{ maxLength: 4, minLength: 1 }}
                                        size="small"
                                    />
                                    <AutoCompleteTools
                                        name="presentacion"
                                        label="Presentación:"
                                        data={articuloPayLoad}
                                        options={listaPresentacionesAutoComplete}
                                        disabled={statusEditArticulo}
                                        onChange={handleChangeDataArticuloPayload}
                                        required={true}
                                        width={"100%"}
                                        error={articuloPayLoad?.presentacion.error}
                                        helperText={articuloPayLoad?.presentacion.helper}
                                        maxLength={50}
                                    />
                                    <AutoCompleteTools
                                        name="marca"
                                        label="Marca:"
                                        data={articuloPayLoad}
                                        options={listaMarcasAutoComplete}
                                        disabled={statusEditArticulo}
                                        onChange={handleChangeDataArticuloPayload}
                                        required={true}
                                        width={"100%"}
                                        error={articuloPayLoad?.marca.error}
                                        helperText={articuloPayLoad?.marca.helper}
                                        maxLength={50}
                                    />
                                    <AutoCompleteTools
                                        name="material"
                                        label="Material:"
                                        data={articuloPayLoad}
                                        options={listaMaterialesAutoComplete}
                                        disabled={statusEditArticulo}
                                        onChange={handleChangeDataArticuloPayload}
                                        required={true}
                                        width={"100%"}
                                        error={articuloPayLoad?.material.error}
                                        helperText={articuloPayLoad?.material.helper}
                                        maxLength={50}
                                    />
                                    <AutoCompleteTools
                                        name="color"
                                        label="Color:"
                                        data={articuloPayLoad}
                                        options={listaColoresAutoComplete}
                                        disabled={statusEditArticulo}
                                        onChange={handleChangeDataArticuloPayload}
                                        maxLength={180}
                                        required={true}
                                        width={"100%"}
                                        error={articuloPayLoad?.color.error}
                                        helperText={articuloPayLoad?.color.helper}
                                    />
                                </div>
                                <div className="rowDetallesArticulo rowDetallesArticulo--main-3">
                                    <AutoCompleteTools
                                        name="familia"
                                        label="Familia:"
                                        data={articuloPayLoad}
                                        options={listaFamiliasAutoComplete}
                                        disabled={statusEditArticulo}
                                        onChange={handleChangeDataArticuloPayload}
                                        maxLength={30}
                                        required={true}
                                        width={"100%"}
                                        error={articuloPayLoad?.familia.error}
                                        helperText={articuloPayLoad?.familia.helper}
                                    />
                                    <AutoCompleteTools
                                        name="subfamilia"
                                        label="Subfamilia:"
                                        data={articuloPayLoad}
                                        options={listaSubfamiliasAutoComplete}
                                        disabled={statusEditArticulo}
                                        onChange={handleChangeDataArticuloPayload}
                                        maxLength={30}
                                        required={true}
                                        width={"100%"}
                                        error={articuloPayLoad?.subfamilia.error}
                                        helperText={articuloPayLoad?.subfamilia.helper}
                                    />
                                    <AutoCompleteTools
                                        name="fabricante"
                                        label="Fabricante:"
                                        data={articuloPayLoad}
                                        options={listaProveedoresAutoComplete}
                                        disabled={statusEditArticulo}
                                        onChange={handleChangeDataArticuloPayload}
                                        maxLength={50}
                                        required={true}
                                        width={"100%"}
                                        error={articuloPayLoad?.fabricante.error}
                                        helperText={articuloPayLoad?.fabricante.helper}
                                    />
                                </div>
                                <div className="rowDetallesArticulo rowDetallesArticulo--main-6">
                                    <AutoCompleteTools
                                        name="ivacompra"
                                        label="IVA Compra:"
                                        data={articuloPayLoad}
                                        options={opcionesIVACompra}
                                        disabled={statusEditArticulo}
                                        onChange={handleChangeDataArticuloPayload}
                                        maxLength={5}
                                        required={true}
                                        width={"100%"}
                                        error={articuloPayLoad?.ivacompra.error}
                                        helperText={articuloPayLoad?.ivacompra.helper}
                                    />
                                    <AutoCompleteTools
                                        name="ivaventa"
                                        label="IVA Venta:"
                                        data={articuloPayLoad}
                                        options={opcionesIVAVenta}
                                        disabled={statusEditArticulo}
                                        onChange={handleChangeDataArticuloPayload}
                                        maxLength={5}
                                        required={true}
                                        width={"100%"}
                                        error={articuloPayLoad?.ivaventa.error}
                                        helperText={articuloPayLoad?.ivaventa.helper}
                                    />
                                    <AutoCompleteTools
                                        name="exentoiva"
                                        label="Exento IVA:"
                                        data={articuloPayLoad}
                                        options={exentoIVA}
                                        disabled={statusEditArticulo}
                                        onChange={handleChangeDataArticuloPayload}
                                        maxLength={2}
                                        required={true}
                                        width={"100%"}
                                        error={articuloPayLoad?.exentoiva.error}
                                        helperText={articuloPayLoad?.exentoiva.helper}
                                    />
                                    <TextField
                                        name="porcentajeiva"
                                        label="Porcentaje IVA:"
                                        value={articuloPayLoad.porcentajeiva.value || ""}
                                        onChange={handleChangeDataArticuloPayload}
                                        disabled={statusEditArticulo}
                                        required
                                        autoComplete="off"
                                        sx={{ width: '100%' }}
                                        inputProps={{ maxLength: 6, minLength: 2 }}
                                        error={articuloPayLoad?.porcentajeiva.error}
                                        helperText={articuloPayLoad?.porcentajeiva.helper}
                                        size="small"
                                    />
                                    <TextField
                                        name="codigocomun"
                                        label="Código común:"
                                        value={articuloPayLoad.codigocomun.value || ""}
                                        onChange={handleChangeDataArticuloPayload}
                                        disabled={statusEditArticulo}
                                        required
                                        autoComplete="off"
                                        sx={{ width: '100%' }}
                                        inputProps={{ maxLength: 13 }}
                                        error={articuloPayLoad?.codigocomun.error}
                                        helperText={articuloPayLoad?.codigocomun.helper}
                                        size="small"
                                    />
                                    <TextField
                                        name="status"
                                        label="Status artículo:"
                                        value={articuloPayLoad.status.value.trim() || ""}
                                        disabled
                                        autoComplete="off"
                                        sx={{ width: '100%' }}
                                        inputProps={{ maxLength: 13 }}
                                        size="small"
                                    />
                                </div>
                            </div>
                            {imagenBase64 && (
                                <div className="imagenArticulo">
                                    <img
                                        src={imagenBase64}
                                        alt="Vista artículo"
                                        style={{ width: "100%", height: "100%", objectFit: "contain", borderRadius: 8 }}
                                    />
                                </div>
                            )}
                            {/* <div className="imagenArticulo">
                                    <img
                                        src={imagenBase64}
                                        alt="Vista artículo"
                                        style={{ width: "100%", height: "100%", objectFit: "contain", borderRadius: 8 }}
                                    />
                                </div> */}
                        </div>
                    </Box>
                    <div className="footArticulos">
                        <Tabs
                            value={tabIndex}
                            onChange={handleChange}
                            aria-label="basic tabs example"
                            sx={{ minHeight: '32px', height: '32px' }}
                        >
                            <Tab label="Medidas" {...a11yProps(0)} sx={{ minHeight: '32px', textTransform: 'none', fontWeight: 'bold' }} />
                            <Tab label="Inventarios" {...a11yProps(1)} sx={{ minHeight: '32px', textTransform: 'none', fontWeight: 'bold' }} />
                            <Tab label="Proveedores" {...a11yProps(2)} sx={{ minHeight: '32px', textTransform: 'none', fontWeight: 'bold' }} />
                        </Tabs>
                        <CustomTabPanel className="marcoMedidas" value={tabIndex} index={0}>
                            <Box className="medidasCostosCombos" sx={{
                                position: 'fixed',
                                bottom: '10px',
                                left: '20px',
                                right: '20px',
                                borderRadius: '12px',
                                zIndex: 1100,
                                backgroundColor: '#fff',
                                boxShadow: '0 -4px 20px rgba(0,0,0,0.15)',
                                display: 'flex',
                                flexWrap: 'nowrap',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: 1,
                                px: 3,
                                py: '8px',
                                borderTop: '1px solid #ddd',
                                transition: 'all 0.3s ease'
                            }}>
                                <TextField
                                    name="formula"
                                    label="Formula:"
                                    value={formularioMedidas.formula || ""}
                                    onChange={handleChangeFormulario}
                                    autoComplete="off"
                                    disabled={statusEditArticulo}
                                    sx={{ width: '210px' }}
                                    inputProps={{ maxLength: 100 }}
                                    size="small"
                                    style={{ fontSize: '13px' }}
                                />
                                <TextField
                                    name="preciosugerido"
                                    label="Precio sugerido:"
                                    value={formularioMedidas.preciosugerido || 0}
                                    onChange={handleChangeFormulario}
                                    autoComplete="off"
                                    disabled
                                    sx={{ width: '120px' }}
                                    inputProps={{ maxLength: 13 }}
                                    size="small"
                                    style={{ fontSize: '13px' }}
                                />
                                <TextField
                                    name="preciodefinitivo"
                                    label="Precio definitivo:"
                                    value={formularioMedidas.preciodefinitivo || 0}
                                    onChange={handleChangeFormulario}
                                    autoComplete="off"
                                    disabled={statusEditArticulo}
                                    sx={{ width: '120px' }}
                                    inputProps={{ maxLength: 13 }}
                                    size="small"
                                    style={{ fontSize: '13px' }}
                                />
                                <TextField
                                    name="pmvb"
                                    label="PMVB:"
                                    value={formularioMedidas.pmvb || 0}
                                    onChange={handleChangeFormulario}
                                    autoComplete="off"
                                    disabled={statusEditArticulo}
                                    sx={{ width: '120px' }}
                                    inputProps={{ maxLength: 13 }}
                                    size="small"
                                    style={{ fontSize: '13px' }}
                                />
                                <Autocomplete
                                    freeSolo
                                    noOptionsText="Sin resultados"
                                    disableClearable
                                    id="descripcion"
                                    options={listaCorridas}
                                    getOptionLabel={(option) => typeof option === "string" ? option : option.descripcion}
                                    value={listaCorridas.find((x) => x.descripcion === corridaSeleccionada) || corridaSeleccionada}
                                    onChange={handleChangeCorridas}
                                    renderInput={(params) => (
                                        <TextField autoComplete="off" {...params} label="Corridas:" required size="small" />
                                    )}
                                    sx={{ width: "300px" }}
                                    disabled={statusEditArticulo}
                                />
                                <Tooltip title="Ir a Catálogo de Corridas">
                                    <IconButton onClick={() => navigate('/corridas')} color="primary">
                                        <ListAltIcon />
                                    </IconButton>
                                </Tooltip>
                                <div className="boxbuttons">
                                    <Tooltip className="botonesmedidas" title={statusEditArticulo || !articuloSeleccionado.clavearticulo || articuloSeleccionado.clavearticulo.trim() === "" ? "Seleccione un artículo primero" : "Grabar medidas"} disableInteractive>
                                        <span>
                                            <IconButton
                                                onClick={handleRegistrarMedidas}
                                                sx={{
                                                    border: "2px solid #23165dff",
                                                    boxShadow: "0 4px 10px rgba(0,0,0,0.3)",
                                                    transition: "all 0.2s ease-in-out",
                                                    backgroundColor: "#fff",
                                                    opacity: (statusEditArticulo || !articuloSeleccionado.clavearticulo || articuloSeleccionado.clavearticulo.trim() === "") ? 0.5 : 1,
                                                    "&:hover": {
                                                        backgroundColor: "#e3f2fd",
                                                        transform: "scale(1.1)",
                                                        boxShadow: "0 6px 14px rgba(0,0,0,0.4)",
                                                    },
                                                    "&:active": {
                                                        transform: "scale(0.95)",
                                                    }
                                                }}
                                                disabled={statusEditArticulo || !articuloSeleccionado.clavearticulo || articuloSeleccionado.clavearticulo.trim() === ""}
                                            >
                                                <UpdateIcon color="primary" />
                                            </IconButton>
                                        </span>
                                    </Tooltip>
                                    <Tooltip className="botonesmedidas" title={statusEditArticulo || !articuloSeleccionado.clavearticulo || articuloSeleccionado.clavearticulo.trim() === "" ? "Seleccione un artículo primero" : "Cambiar código barras"} disableInteractive>
                                        <span>
                                            <IconButton
                                                onClick={handleModalCambioCodigoBarras}
                                                sx={{
                                                    border: "2px solid #23165dff",
                                                    boxShadow: "0 4px 10px rgba(0,0,0,0.3)",
                                                    transition: "all 0.2s ease-in-out",
                                                    backgroundColor: "#fff",
                                                    opacity: (statusEditArticulo || !articuloSeleccionado.clavearticulo || articuloSeleccionado.clavearticulo.trim() === "") ? 0.5 : 1,
                                                    "&:hover": {
                                                        backgroundColor: "#e3f2fd",
                                                        transform: "scale(1.1)",
                                                        boxShadow: "0 6px 14px rgba(0,0,0,0.4)",
                                                    },
                                                    "&:active": {
                                                        transform: "scale(0.95)",
                                                    }
                                                }}
                                                disabled={statusEditArticulo || !articuloSeleccionado.clavearticulo || articuloSeleccionado.clavearticulo.trim() === ""}
                                            >
                                                <QrCodeScannerIcon color="primary" />
                                            </IconButton>
                                        </span>
                                    </Tooltip>
                                    <Tooltip className="botonesmedidas" title={statusEditArticulo || !articuloSeleccionado.clavearticulo || articuloSeleccionado.clavearticulo.trim() === "" ? "Seleccione un artículo primero" : "Restablecer código barras"} disableInteractive>
                                        <span>
                                            <IconButton
                                                onClick={() => handleClickGuardarCodigoBarras(articuloSeleccionado.clavearticulo.trim() + medidaSeleccionada.medida)}
                                                sx={{
                                                    border: "2px solid #23165dff",
                                                    boxShadow: "0 4px 10px rgba(0,0,0,0.3)",
                                                    transition: "all 0.2s ease-in-out",
                                                    backgroundColor: "#fff",
                                                    opacity: (statusEditArticulo || !articuloSeleccionado.clavearticulo || articuloSeleccionado.clavearticulo.trim() === "") ? 0.5 : 1,
                                                    "&:hover": {
                                                        backgroundColor: "#e3f2fd",
                                                        transform: "scale(1.1)",
                                                        boxShadow: "0 6px 14px rgba(0,0,0,0.4)",
                                                    },
                                                    "&:active": {
                                                        transform: "scale(0.95)",
                                                    }
                                                }}
                                                disabled={statusEditArticulo || !articuloSeleccionado.clavearticulo || articuloSeleccionado.clavearticulo.trim() === ""}
                                            >
                                                <RepartitionIcon color="primary" />
                                            </IconButton>
                                        </span>
                                    </Tooltip>
                                    <Tooltip className="botonesmedidas" title={statusEditArticulo || !articuloSeleccionado.clavearticulo || articuloSeleccionado.clavearticulo.trim() === "" ? "Seleccione un artículo primero" : "Eliminar medida del artículo"} disableInteractive>
                                        <span>
                                            <IconButton
                                                onClick={() => setStatusOpenModalEliminarMedidas(true)}
                                                sx={{
                                                    border: "2px solid #23165dff",
                                                    boxShadow: "0 4px 10px rgba(0,0,0,0.3)",
                                                    transition: "all 0.2s ease-in-out",
                                                    backgroundColor: "#fff",
                                                    opacity: (statusEditArticulo || !articuloSeleccionado.clavearticulo || articuloSeleccionado.clavearticulo.trim() === "") ? 0.5 : 1,
                                                    "&:hover": {
                                                        backgroundColor: "#e3f2fd",
                                                        transform: "scale(1.1)",
                                                        boxShadow: "0 6px 14px rgba(0,0,0,0.4)",
                                                    },
                                                    "&:active": {
                                                        transform: "scale(0.95)",
                                                    }
                                                }}
                                                disabled={statusEditArticulo || !articuloSeleccionado.clavearticulo || articuloSeleccionado.clavearticulo.trim() === ""}
                                            >
                                                <DeleteIcon color="primary" />
                                            </IconButton>
                                        </span>
                                    </Tooltip>
                                    <Tooltip className="botonesmedidas" title={statusEditArticulo || !articuloSeleccionado.clavearticulo || articuloSeleccionado.clavearticulo.trim() === "" || !medidasList || medidasList.length === 0 ? "Seleccione un artículo primero" : "Eliminar todas las medidas del artículo"} disableInteractive>
                                        <span>
                                            <IconButton
                                                onClick={() => setStatusOpenModalEliminarTodasMedidas(true)}
                                                sx={{
                                                    border: "2px solid #d32f2f",
                                                    boxShadow: "0 4px 10px rgba(0,0,0,0.3)",
                                                    transition: "all 0.2s ease-in-out",
                                                    backgroundColor: "#fff",
                                                    opacity: (statusEditArticulo || !articuloSeleccionado.clavearticulo || articuloSeleccionado.clavearticulo.trim() === "" || !medidasList || medidasList.length === 0) ? 0.5 : 1,
                                                    "&:hover": {
                                                        backgroundColor: "#ffebee",
                                                        transform: "scale(1.1)",
                                                        boxShadow: "0 6px 14px rgba(0,0,0,0.4)",
                                                    },
                                                    "&:active": {
                                                        transform: "scale(0.95)",
                                                    }
                                                }}
                                                disabled={statusEditArticulo || !articuloSeleccionado.clavearticulo || articuloSeleccionado.clavearticulo.trim() === "" || !medidasList || medidasList.length === 0}
                                            >
                                                <DeleteIcon color="error" />
                                            </IconButton>
                                        </span>
                                    </Tooltip>
                                </div>
                            </Box>
                            <div className="tablaMedidas" style={{ paddingBottom: '160px', maxHeight: 'calc(100vh - 410px)', overflowY: 'auto' }}>
                                <SizeSoftXTableVentas
                                    columns={[
                                        { title: "Medida", field: "medida" },
                                        { title: "Formulario", field: "formulario" },
                                        { title: "Precio sugerido", field: "preciosugerido" },
                                        { title: "Precio definitivo", field: "preciodefinitivo" },
                                        { title: "PMVB", field: "pmvb" },
                                        { title: "CUC", field: "cuc" },
                                        { title: "Código de barras", field: "codigobarras" },
                                        { title: "Fecha ajuste", field: "fechaajuste" },
                                        { title: "Usuario ajuste", field: "usuarioajuste" },
                                    ]}
                                    data={Array.isArray(medidasList) ? medidasList : []}
                                    id="medida"
                                    row={medidaSeleccionada}
                                    setRow={handleChangeMedidaSeleccionada}
                                    fontSize="small"
                                    rowsPerPageIntro={50}
                                />
                            </div>
                        </CustomTabPanel>
                        <CustomTabPanel value={tabIndex} index={1}>
                            <Box className="medidasCostosCombos" sx={{
                                position: 'fixed',
                                bottom: '10px',
                                left: '20px',
                                right: '20px',
                                borderRadius: '12px',
                                zIndex: 1100,
                                backgroundColor: '#fff',
                                boxShadow: '0 -4px 20px rgba(0,0,0,0.15)',
                                display: 'flex',
                                flexWrap: 'nowrap',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: 1,
                                px: 3,
                                py: '8px',
                                borderTop: '1px solid #ddd',
                                transition: 'all 0.3s ease'
                            }}>
                                <div className="body-form">
                                    <Autocomplete
                                        freeSolo
                                        noOptionsText={"Sin resultados"}
                                        disableClearable
                                        id={"id"}
                                        name={"AlmacenExhibidor"}
                                        options={listaAlmacenesExhibidoresAutoComplete}
                                        getOptionLabel={(option) => typeof option === "string" ? option : option.nombre}
                                        value={listaAlmacenesExhibidoresAutoComplete.find(x => x.nombre === almacenexhibidor) || almacenexhibidor}
                                        onChange={(e, newDat) => handleChangeAlmacenExhibidor(e, newDat)}
                                        renderInput={(params) => (
                                            <TextField {...params} label="Almacén o Exhibidor:" required />
                                        )}
                                        sx={{ width: '300px', height: '50px', margin: '12px' }}
                                    />
                                </div>
                            </Box>
                            <div className="body-Detalles-Existencias">
                                <SizeSoftXTableExistencias
                                    columns={[
                                        { title: "Descripción", field: "descripcion", hideSort: false },
                                    ]}
                                    data={dataFiltroExistencias == null ? [] : dataFiltroExistencias}
                                    id="id"
                                    row={dataArticuloExistencia}
                                    setRow={handleArticuloSeleccionado}
                                    setClave={setClaveArticuloExistencia}
                                    setMedida={setMedidaArticuloExistencia}
                                    fontSize="small"
                                    rowsPerPageIntro={50}
                                />
                            </div>
                            <div className="body-pie-entradas-salidas">
                                <div className="detalles-entrada-salida">
                                    <TextField autoComplete="off"
                                        name="totalregistros"
                                        label="Total registros:"
                                        value={totalRegistros}
                                        sx={{ width: '200px', height: '7.2vh' }}
                                        disabled
                                    />
                                </div>
                                <div className="detalles-entrada-salida">
                                    <TextField autoComplete="off"
                                        name="totalpares"
                                        label="Cantidad de artículos:"
                                        value={cantidadArticulos}
                                        sx={{ width: '200px', height: '7.2vh' }}
                                        disabled
                                    />
                                </div>
                            </div>
                        </CustomTabPanel>
                        <CustomTabPanel value={tabIndex} index={2}>
                            <SizeSoftXTableVentas
                                columns={[
                                    {
                                        title: "Status",
                                        hideSort: false,
                                        field: "status",
                                        render: (row) => (
                                            <div>
                                                <input
                                                    type="checkbox"
                                                    name="statuscheck"
                                                    checked={row.status}
                                                    disabled={statusEditArticulo}
                                                    onChange={(event) => handleChangeStatus(event, row)}
                                                />
                                            </div>
                                        )
                                    },
                                    { title: "Clave proveedor", field: "clavefabricante" },
                                    { title: "Nombre proveedor", field: "nombrefabricante" },
                                ]}
                                id={"clavefabricante"}
                                data={listaProveedoresArticulo ?? []}
                                onChange={handleChangeStatus}
                                row={rowSelectProveedores}
                                setRow={handleChangeProveedorSeleccionado}
                                fontSize="small"
                                rowsPerPageIntro={50}
                            />
                        </CustomTabPanel>
                    </div>
                </Box>
            </SizeSoftXLayout>
            <ArticulosEliminar />
            <ModalBuscarArticulosSimple
                openModal={statusBuscarArticuloSimple}
                handleCloseModal={handleCerrarBuscarArticulo}
                dominio={parametrosCajaForm.dominio}
                handleArticuloSelect={handleCargarArticulo}
            />
            <SizeSoftXModalInputBox
                open={statusOpenCodigoBarras}
                title={"Cambiar código barras"}
                onClose={() => setStatusOpenCodigoBarras(false)}
                onSuccess={handleCambioCodigoBarrasSuccess}
                success="Cambiar"
            />
            <SizeSoftXModal
                open={statusOpenModalEliminarMedidas}
                title={"¿Está seguro de querer eliminar la medida del artículo? Esta acción eliminará toda la información del sistema"}
                onClose={() => setStatusOpenModalEliminarMedidas(false)}
                onSuccess={handleClickEliminarMedidaArticulo}
                success="Eliminar medida"
            />
            <SizeSoftXModal
                open={statusOpenModalEliminarTodasMedidas}
                title={"¿Está seguro de eliminar TODAS las medidas del artículo? Esta acción eliminará todas las medidas, existencias y movimientos de almacén. Las ventas y cotizaciones NO se eliminarán."}
                onClose={() => setStatusOpenModalEliminarTodasMedidas(false)}
                onSuccess={handleClickEliminarTodasMedidasArticulo}
                success="Eliminar todas las medidas"
            />
            <SizeSoftXModal
                open={statusOpenModalEliminarArticulo}
                title={"¿Está seguro de querer eliminar el artículo? Esta acción eliminará toda la información del sistema"}
                onClose={() => setStatusOpenModalEliminarArticulo(false)}
                onSuccess={handleClickEliminarArticulo}
                success="Eliminar artículo"
            />
            <SizeSoftXModal
                open={openConfirmSaveModal}
                title="Confirmar guardado de corridas"
                onClose={() => {
                    setOpenConfirmSaveModal(false);
                    setPendingSaveData(null);
                }}
                onSuccess={handleConfirmarRegistrarMedidas}
                success="Guardar"
            >
                <Box sx={{ p: 2 }}>
                    <Typography variant="subtitle2">
                        Artículo: {pendingSaveData?.clavearticulo}
                    </Typography>
                    <Typography variant="subtitle2">
                        Corrida: {pendingSaveData?.corrida}
                    </Typography>
                    <Divider sx={{ my: 1 }} />
                    <Typography>
                        Fórmula: {pendingSaveData?.formula}
                    </Typography>
                    <Typography>
                        Precio sugerido: {pendingSaveData?.preciosugerido}
                    </Typography>
                    <Typography>
                        Precio definitivo: {pendingSaveData?.preciodefinitivo}
                    </Typography>
                    <Typography>
                        PMVB: {pendingSaveData?.pmvb}
                    </Typography>
                </Box>
            </SizeSoftXModal>
            <TenantSyncModal
                open={openTenantSync}
                onClose={() => setOpenTenantSync(false)}
                syncType="ARTICLES"
                itemKeys={articuloSeleccionado?.clavearticulo ? [articuloSeleccionado.clavearticulo.trim()] : []}
                title="Sincronizar articulo"
            />
        </Fragment>
    );
}
